import { lazy } from "react";
import { ArrowRightLeft, Blend, ClipboardPen, CookingPot, LogOut, PackageOpen, Printer } from "lucide-react";
import { defineWebModule } from "../../web/module";
import "./web/feeding.css";

// Pages load when opened, so the app starts fast on a phone with weak signal.
const AnimalFeedSection = lazy(() => import("./web/Lots").then((m) => ({ default: m.AnimalFeedSection })));
const FeedDetails = lazy(() => import("./web/Rations").then((m) => ({ default: m.FeedDetails })));
const LotSection = lazy(() => import("./web/Lots").then((m) => ({ default: m.LotSection })));
const PenSection = lazy(() => import("./web/Pen").then((m) => ({ default: m.PenSection })));
const CallForm = lazy(() => import("./web/forms").then((m) => ({ default: m.CallForm })));
const CloseoutJob = lazy(() => import("./web/Closeout").then((m) => ({ default: m.CloseoutJob })));
const DeliveryForm = lazy(() => import("./web/forms").then((m) => ({ default: m.DeliveryForm })));
const FeedEventDetail = lazy(() => import("./web/Detail").then((m) => ({ default: m.FeedEventDetail })));
const FeedingSettings = lazy(() => import("./web/Settings").then((m) => ({ default: m.FeedingSettings })));
const FeedingWorkspace = lazy(() => import("./web/Workspace").then((m) => ({ default: m.FeedingWorkspace })));
const LoadForm = lazy(() => import("./web/forms").then((m) => ({ default: m.LoadForm })));
const RationsSection = lazy(() => import("./web/Rations").then((m) => ({ default: m.RationsSection })));
const ReceiveForm = lazy(() => import("./web/forms").then((m) => ({ default: m.ReceiveForm })));

export default defineWebModule({
  id: "feeding",
  icons: { feedReceive: PackageOpen, feedMove: ArrowRightLeft, feedOut: LogOut, feedCall: ClipboardPen, feedLoad: Blend, feedRation: CookingPot, feedPrint: Printer },
  events: {
    "feeding.call": { Form: CallForm, Detail: FeedEventDetail },
    "feeding.delivery": { Form: DeliveryForm, Detail: FeedEventDetail },
    "feeding.receive": { Form: ReceiveForm, Detail: FeedEventDetail },
    "feeding.load": { Form: LoadForm, Detail: FeedEventDetail },
  },
  workspaces: { feeding: FeedingWorkspace },
  ranchSections: { rations: RationsSection },
  jobs: { "feeding.closeout": CloseoutJob },
  animalSections: [{ id: "feeding", label: "On feed", order: 60, show: (a) => !!a.facets.feeding, Component: AnimalFeedSection }],
  placeSections: [{ id: "feeding", label: "Feeding", order: 20, show: (p) => !!p.facets?.feeding, Component: PenSection }],
  groupSections: [{ id: "feeding", label: "On feed", order: 20, show: (g) => g.kind === "lot", Component: LotSection }],
  stockSections: [{ id: "feeding", label: "Feed details", order: 20, show: (s) => s.kind === "feed" || s.kind === "ingredient", Component: FeedDetails }],
  Settings: FeedingSettings,
});
